module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/estadisticas-greyLight.261952c3.svg";